<template>
  <Modal :class="computedPersonModalClasses" @modalClose="onClose">
    <div class="modal-header">
      <h4 v-if="personListType">{{personListType}}</h4>
      <h4 v-else>เพิ่ม ผู้ดำเนินรายการ/นักแสดง</h4>
      <button
        @click.stop="onClose"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form v-on:submit.prevent="onSubmit">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-7">
            <FormGroup :errorMessage="updatePersonStateError.firstname">
              <h5 class="name">ชื่อจริง</h5>
              <input
                type="text"
                placeholder="ชื่อจริง"
                class="form-control"
                :class="{'is-invalid': updatePersonStateError.firstname}"
                v-model="newPerson.firstName"
                />
              <div
                class="invalid-feedback"
                v-if="updatePersonStateError.firstname">
                {{updatePersonStateError.firstname}}
              </div>
            </FormGroup>
            <FormGroup :errorMessage="updatePersonStateError.lastname">
              <h5 class="name">นามสกุล</h5>
              <input
                type="text"
                placeholder="นามสกุล"
                class="form-control"
                :class="{'is-invalid': updatePersonStateError.lastName}"
                v-model="newPerson.lastName"
                />
              <div
                class="invalid-feedback"
                v-if="updatePersonStateError.lastName">
                {{updatePersonStateError.lastName}}
              </div>
            </FormGroup>
            <FormGroup :errorMessage="updatePersonStateError.lastName">
              <h5 class="Name">ชื่อเล่น</h5>
              <input
                type="text"
                placeholder="ชื่อเล่น"
                class="form-control"
                :class="{'is-invalid': updatePersonStateError.nickName}"
                v-model="newPerson.nickName"
                />
              <div
                class="invalid-feedback"
                v-if="updatePersonStateError.nickName">
                {{updatePersonStateError.nickName}}
              </div>
            </FormGroup>
            <FormGroup :errorMessage="updatePersonStateError.character">
              <h5 class="Name">บทบาท</h5>
              <input
                type="text"
                placeholder="บทบาท"
                class="form-control"
                v-model="newPerson.character"
                ref="test" />
            </FormGroup>
          </div>
          <div class="col-md-5">
            <FormGroup>
              <ImageField
                :image.sync="newPerson.displayImage"
                aspectRatio="1:1"
                imageViewSize="cover640w640h"
                hintText="ขนาดภาพที่เหมาะสม 640x640"
                ref="personDisplayImageUploader" />
            </FormGroup>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button"
          class="btn btn-link">ยกเลิก
        </button>
        <div class="submit-button-wrapper ml-auto">
          <small class="text-danger mr-3" v-if="!isValid">*โปรดใส่ข้อมูล ชื่อจริง หรือ นามสกุล หรือ ชื่อเล่น</small>
          <button type="submit"
            class="btn btn-primary"
            :disabled="!isValid">บันทึก
          </button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import ImageField from '@/image/ImageField.vue';

export default {
  props: {
    personListType: {
      type: String,
      default: '',
    },
    person: {
      type: Object,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    onUpdated: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    FormGroup,
    Modal,
    ImageField,
  },
  data() {
    return {
      newPerson: {
        firstName: '',
        lastName: '',
        nickName: '',
        character: '',
        displayImage: null,
      },
      updatePersonStateError: {
        firstName: null,
        lastName: null,
        character: null,
      },
      errorStatus: null,
      personDisplayImageUploader: null,
    };
  },
  created() {
    this.newPerson = _.defaultsDeep(this.person, this.newPerson);
  },
  mounted() {
    this.personDisplayImageUploader = this.$refs.personDisplayImageUploader;
  },
  computed: {
    isValid() {
      return this.newPerson.firstName || this.newPerson.lastName || this.newPerson.nickName;
    },
    personDisplayImageUploaderShowing() {
      return this.personDisplayImageUploader && this.personDisplayImageUploader.isImageUploaderModalShowing;
    },
    computedPersonModalClasses() {
      if (this.personDisplayImageUploaderShowing) {
        return 'modal-insider-showing';
      }
      return '';
    },
  },
  methods: {
    onSubmit() {
      this.onUpdated(this.newPerson);
    },
  },
  beforeDestroy() {
    this.personDisplayImageUploader = null;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.modal-insider-showing > /deep/ .modal-content {
  height: 668px;
  border: 0;
  > .modal-header {
    opacity: 0;
  }
  .modal-container {
    overflow: hidden;
  }
}


</style>
